var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5002 1H8.50023V1.79929C8.50023 2.18516 8.18725 2.50013 7.7994 2.50013H7.19899C6.81311 2.50013 6.49815 2.18714 6.49815 1.79929V1H3.50005V1.79929C3.50005 2.18516 3.18707 2.50013 2.79922 2.50013H2.19881C1.81293 2.50013 1.49797 2.18714 1.49797 1.79929V1H0.499982C0.224434 1 0 1.22443 0 1.49998V9.50006C0 9.7756 0.224434 10 0.499982 10H9.50002C9.77557 10 10 9.7756 10 9.50006V1.50016C10 1.22461 9.77557 1.00018 9.50002 1.00018L9.5002 1ZM9.00022 8.79922C9.00022 8.90936 8.91167 9.00007 8.79936 9.00007H1.20082C1.09067 9.00007 0.999964 8.91152 0.999964 8.79922V4.20075C0.999964 4.0906 1.08851 3.99989 1.20082 3.99989H8.79936C8.90951 3.99989 9.00022 4.08844 9.00022 4.20075V8.79922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20086 1.99993H7.80127C7.91141 1.99993 8.00212 1.91138 8.00212 1.79907V0.200857C8.00212 0.0907095 7.91357 0 7.80127 0H7.20086C7.09071 0 7 0.0885497 7 0.200857V1.80123C7 1.90958 7.08855 2.00011 7.20086 2.00011V1.99993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.20086 1.99993H2.80127C2.91141 1.99993 3.00212 1.91138 3.00212 1.79907V0.200857C3.00212 0.0907095 2.91357 0 2.80127 0H2.20086C2.09071 0 2 0.0885497 2 0.200857V1.80123C2 1.90958 2.09053 2.00011 2.20086 2.00011V1.99993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30127 5H2.70086C2.59071 5 2.5 5.08855 2.5 5.20086V5.80127C2.5 5.91141 2.58855 6.00212 2.70086 6.00212H3.30127C3.41141 6.00212 3.50212 5.91357 3.50212 5.80127V5.20086C3.50212 5.09071 3.41357 5 3.30127 5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30127 5H4.70086C4.59071 5 4.5 5.08855 4.5 5.20086V5.80127C4.5 5.91141 4.58855 6.00212 4.70086 6.00212H5.30127C5.41141 6.00212 5.50212 5.91357 5.50212 5.80127V5.20086C5.50212 5.09071 5.41159 5 5.30127 5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29345 5H6.69304C6.5829 5 6.49219 5.08855 6.49219 5.20086V5.80127C6.49219 5.91141 6.58074 6.00212 6.69304 6.00212H7.29345C7.4036 6.00212 7.49431 5.91357 7.49431 5.80127V5.20086C7.49431 5.09071 7.40378 5 7.29345 5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30127 7H2.70086C2.59071 7 2.5 7.08855 2.5 7.20086V7.80127C2.5 7.91141 2.58855 8.00212 2.70086 8.00212H3.30127C3.41141 8.00212 3.50212 7.91357 3.50212 7.80127V7.20086C3.50212 7.08873 3.41357 7 3.30127 7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30127 7H4.70086C4.59071 7 4.5 7.08855 4.5 7.20086V7.80127C4.5 7.91141 4.58855 8.00212 4.70086 8.00212H5.30127C5.41141 8.00212 5.50212 7.91357 5.50212 7.80127V7.20086C5.50212 7.08873 5.41159 7 5.30127 7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29345 7H6.69304C6.5829 7 6.49219 7.08855 6.49219 7.20086V7.80127C6.49219 7.91141 6.58074 8.00212 6.69304 8.00212H7.29345C7.4036 8.00212 7.49431 7.91357 7.49431 7.80127V7.20086C7.49431 7.08873 7.40378 7 7.29345 7Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/Calendar-Icon.17db61192cd0eecaeff91d1534a2f5b5.svg";
export { ForwardRef as ReactComponent };